import React, { useEffect } from 'react';
import Animated, { useSharedValue, useAnimatedStyle, withRepeat, withTiming } from 'react-native-reanimated';

import { PENDING_PULSE } from '@components/search/operations/components/StartJobPopup/components/SendStatus/constants';
import type { ShimmerLabelProps } from './types';

const ShimmerLabel = ({ content, C, font }: ShimmerLabelProps) => {
  const opacity = useSharedValue(1);

  useEffect(() => {
    opacity.value = withRepeat(withTiming(PENDING_PULSE.min, { duration: PENDING_PULSE.duration }), -1, true);
  }, [opacity]);

  const pulseStyle = useAnimatedStyle(() => ({ opacity: opacity.value }));

  return (
    <Animated.Text numberOfLines={1} style={[font['Button 2'], { color: C(content.color) }, pulseStyle]}>
      {content.label}
    </Animated.Text>
  );
};

export default ShimmerLabel;
